export const KICKOFF_MODAL_ACTION = 'kickoff_modal_viewed';
export const FURNITURE_SERVICE_STARTED_ACTION = 'tenant_furniture_service_started';
export const TENANT_ONBOARDING_CHECKLIST_ACKNOWLEDGED_ACTION = 'tenant_onboarding_checklist_acknowledged';
export const INTERNET_ONLINE_ACTION = 'internet_online';
export const SUGGESTED_AI_ASSISTANT_PROMPTS = [
  'A light burned out',
  'The AC isn’t working',
  'Order a standing desk',
  'Kitchen sink is leaking',
  'Order more access cards',
  'Schedule a cleaning',
  'Rent a phone booth',
  'We need more trash bags',
  "We're out of oat milk",
  'Order more sparkling water',
  'We need more coffee',
  'Internet is down'
];
